import React, {useContext} from "react";
import {FormModal} from "../../../components";
import common from "@well-b/well-b-shared";
import {PHONE_NUMBER_ERROR_VALIDATION} from "../../../marketplace/consts.jsx";
import {DeliveryProviderDeliveriesContext} from "./DeliveryProviderDeliveriesContext.jsx";

export const DeliveryProviderDeliveriesExternalDriverModal = ({onSave}) => {
    const {externalDriverModalVisibility, closeExternalDriverModal} = useContext(DeliveryProviderDeliveriesContext);

    return (
        <FormModal
            visible={externalDriverModalVisibility}
            header="הוספת שליח חיצוני"
            subTitle="המספר של שליח זה יועבר ללקוח ולצוות תפעול של וולבי"
            onSave={onSave}
            onClose={closeExternalDriverModal}
            fields={[
                {name: "name", label: "שם השליח"},
                {
                    name: "phone",
                    label: "טלפון",
                    rules: [
                        {
                            validator: (_, value) =>
                                common.isValidPhoneMobileNumber(value)
                                    ? Promise.resolve()
                                    : Promise.reject(PHONE_NUMBER_ERROR_VALIDATION)
                        }
                    ]
                }
            ]}
        />
    );
};
